let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aZinD"), load("6qah4"), load("9mjQR"), load("lhkXg")]).then(() => parcelRequire('hLSQl'));